// extracted by mini-css-extract-plugin
export default {"viewForm":"ContactViewForm_viewForm__ketMv","viewItem":"ContactViewForm_viewItem__2P3gR","viewItemValue":"ContactViewForm_viewItemValue__wUHln"};